import Vue from 'vue';
// import store from './store'
import {Loading} from 'element-ui';
import '@/assets/scss/vl-theme.scss';
import '@/assets/css/vlaanderen-ui.css';

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import {BootstrapVue} from 'bootstrap-vue';
Vue.use(BootstrapVue);

import VueAxios from "vue-axios";
import axios from 'axios';
import router from "@/router";
import App from "@/App.vue";

Vue.use(VueAxios, axios);

axios.interceptors.request.use(
    (config) => {
        config.headers = config.headers || {};
        config.headers['Accept'] = 'application/json';
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

Vue.mixin({
    data() {
        return {
            get baseEnergieApiUrl() {
                return process.env.VUE_APP_BASE_API_URL;
            }
        }
    }
});

Vue.config.productionTip = false;

new Vue({
    router,
    // store,
    render: h => h(App)
}).$mount('#app');
